import useNotification from "antd/es/notification/useNotification";
import "./App.css";
import AppRoutes from "./routes/routes";
import { initNotification } from "./widgets/AppToast";

function App() {
  const [api, contextHolder] = useNotification();
  // Initialize the singleton notification API once
  initNotification(api);
  return (
    <>
      {contextHolder}
      <AppRoutes />
    </>
  );
}

export default App;
